import DesktopIcon from '@components/icons/Desktop.svg';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { handleDownloadError, handleOpenDesktop } from '@helpers/jobLinkHelpers';
import { downloadFromUrl } from '@helpers/downloadFromUrl';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import sanitize from 'sanitize-filename';
import { ColumnTitle } from './styles/ColumnTitle';
import { IdField } from './styles/IdField';
import { JobName } from './styles/JobName';
import { LeftSide } from './styles/LeftSide';
import { RightSide } from './styles/RightSide';
import { StyledDesktopButtonIconLink } from './styles/StyledDesktopButtonIconLink';
import { StyledLink } from './styles/StyledLink';
import { Wrapper } from './styles/Wrapper';
import { GetUserDetailsResultDto } from 'app/API';

type TProps = {
  user?: GetUserDetailsResultDto;
};

export const JobHistory = ({ user }: TProps) => {
  const { organization } = useAuthContext();

  if (!user) {
    return null;
  }

  return (
    <Wrapper>
      <LeftSide>
        <h3>Job history</h3>
      </LeftSide>

      <RightSide>
        <div className="flex w-full justify-between">
          <ColumnTitle>
            <h3>Job title</h3>
          </ColumnTitle>

          <ColumnTitle>
            <h3>Date completed</h3>
          </ColumnTitle>

          <ColumnTitle>
            <h3>Transcript</h3>
          </ColumnTitle>
        </div>

        <div className="w-full">
          {user.jobs.map((data) => (
            <div key={data.jobId} className="flex items-center justify-between">
              <div style={{ width: '230px' }}>
                <JobName>
                  <StyledLink
                    to={routes.jobDetails.make(organization?.slug ?? '', data.workspaceSlug ?? '', data.jobId)}
                  >
                    {data.title}
                  </StyledLink>
                </JobName>
                <IdField>{data.jobId}</IdField>
              </div>

              <div key={data.jobId} style={{ width: '230px' }}>
                {data.completed ? getAmericanTime(data.completed) : '-'}
              </div>

              <div className="flex" key={data.jobId} style={{ width: '230px', color: '#40608F' }}>
                <div
                  className="cursor-pointer underline flex"
                  onClick={() => {
                    const fileName = sanitize(data.title)
                      .toLowerCase()
                      .replace(/[^a-zA-Z0-9()_.]/gi, '-');
                    downloadFromUrl(
                      `${window.location.origin}/api/media/${data.jobId}/versions/${data.versionId}`,
                      `${fileName}.docx`,
                    ).catch(handleDownloadError);
                  }}
                >
                  Download
                </div>
                <StyledDesktopButtonIconLink
                  target="_blank"
                  rel="noreferrer"
                  className="ml-8"
                  onClick={() => handleOpenDesktop(data?.jobId || '', data.versionId)}
                >
                  <DesktopIcon />
                </StyledDesktopButtonIconLink>
              </div>
            </div>
          ))}
        </div>
      </RightSide>
    </Wrapper>
  );
};
